import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        perTnsSalarie: [
          !_.isNil(entity?.parameters?.perTnsSalarie)
            ? entity.parameters.perTnsSalarie
            : null,
          [
            this.prFormService.RefreshEveryValidators([
              'perTnsCompanyFirstFiscalYear',
              'perTnsCompanyCreationDate',
            ]),
            Validators.required,
          ],
        ],
        perTnsCompanyFirstFiscalYear: [
          entity?.parameters?.perTnsCompanyFirstFiscalYear || null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo(
                  'perTnsSalarie',
                  val => val === 'TNS',
                )
                .bind(this),
              Validators.required,
            ),
            Validators.nullValidator,
          ],
        ],
        perTnsCompanyCreationDate: [
          entity?.parameters?.perTnsCompanyCreationDate || null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo(
                  'perTnsSalarie',
                  val => val === 'TNS',
                )
                .bind(this),
              Validators.required,
            ),
            Validators.nullValidator,
          ],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
